import { render, staticRenderFns } from "./JurisdictionForm.vue?vue&type=template&id=1876fc94"
import script from "./JurisdictionForm.vue?vue&type=script&lang=js"
export * from "./JurisdictionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports